import {defineAsyncComponent} from 'vue'

export default (app: any) => {
	app.component('backoffice-hotel-res-analysis', defineAsyncComponent(() => import(/* webpackChunkName: "HotelResAnalysis" */ './Index.vue')))
	app.component('backoffice-hotel-res-view', defineAsyncComponent(() => import(/* webpackChunkName: "HotelResView" */ './HotelResView.vue')))
}
